import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Products() {
  return (
    <section className="products-section section-padding">
      <Container>
        <Row>
          <Col className="mx-auto">
            <div className="products-content text-center">
              {/* <h3 className="section-subtitle primary-color mb-4">
                Our Products
              </h3>
              <h2 className="section-title primary-color mb-7">
                FLUO Product Line
              </h2> */}
              <Row className="align-items-center">
                <Col md="12" lg="6" className="my-4">
                  <div className="productitem bottle">
                    <Link to="/shop/">
                      <StaticImage
                        className="img-fluid"
                        src="../../images/bottle.png"
                        alt="Bottle"
                      />
                      <div className="product-text">
                        <svg viewBox="0 0 500 500">
                          <defs>
                            <path
                              d="M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250"
                              id="textcircle"
                            >
                              <animateTransform
                                attributeName="transform"
                                begin="0s"
                                dur="30s"
                                type="rotate"
                                from="0 250 250"
                                to="360 250 250"
                                repeatCount="indefinite"
                              />
                            </path>
                          </defs>
                          <text dy="0" textLength="1280">
                            <textPath href="#textcircle">
                              Bottles & Gear • Bottles & Gear •
                            </textPath>
                          </text>
                        </svg>
                      </div>
                    </Link>
                  </div>
                </Col>
                <Col md="12" lg="6" className="my-4">
                  <div className="productitem cards">
                    <Link to="/shop/">
                      <StaticImage
                        className="img-fluid"
                        src="../../images/cards.png"
                        alt="Cards"
                      />
                      <div className="product-text">
                        <svg viewBox="0 0 500 500">
                          <defs>
                            <path
                              d="M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250"
                              id="textcircle"
                            >
                              <animateTransform
                                attributeName="transform"
                                begin="0s"
                                dur="30s"
                                type="rotate"
                                from="0 250 250"
                                to="360 250 250"
                                repeatCount="indefinite"
                              />
                            </path>
                          </defs>
                          <text dy="0" textLength="1280">
                            <textPath href="#textcircle">
                              Echo Greetings • Echo Greetings •
                            </textPath>
                          </text>
                        </svg>
                      </div>
                    </Link>
                  </div>
                </Col>
                {/* <Col md="12" lg="6" className="my-4">
                  <div className="productitem">
                    <Link to="/shop">
                      <StaticImage
                        className="img-fluid"
                        src="../../images/jewelry.png"
                        alt="Talisman"
                      />
                      <div className="product-text">
                        <svg viewBox="0 0 500 500">
                          <defs>
                            <path
                              d="M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250"
                              id="textcircle"
                            >
                              <animateTransform
                                attributeName="transform"
                                begin="0s"
                                dur="30s"
                                type="rotate"
                                from="0 250 250"
                                to="360 250 250"
                                repeatCount="indefinite"
                              />
                            </path>
                          </defs>
                          <text dy="0" textLength="1280">
                            <textPath href="#textcircle">
                              Jewelry & Accessories • Jewelry & Accessories •
                            </textPath>
                          </text>
                        </svg>
                      </div>
                    </Link>
                  </div>
                </Col> */}
                <Col md="12" lg="6" className="my-4 mx-auto">
                  <div className="productitem">
                    {/* <Link to="" disable> */}
                    <StaticImage
                      className="img-fluid"
                      src="../../images/apparel-coming-soon.png"
                      alt="Apparel"
                    />
                    {/* </Link> */}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
